export default {
    // 员工
    STAFF: 0,
    // 部门
    DEPT: 1,
    // 公司
    COMPANY: 2,
};
